import util from '@bmp-vue/core/api/util'

const controller = 'ArquivoRetornoCNAB'

export default Object.assign({}, util.GetCrud(controller, ['get', 'getall']), {
  Download: (dto) => {
    return util.Axios.PostBlob(controller + '/Download', dto)
  }
})
